<div class="ui modal" id="LiveBets_Keyboard_Search_Modal">
    <div class="ui fluid icon action input" style="margin:10px">
        <input placeholder="Find_Game" type="text" id="KeyboardSearch_Input" style="text-align:left" [(ngModel)]="this.tournamentsService.TerminalSearchValue"/>
        <button class="ui icon button" (click)="KeyboardSearch_Close()">
            <i class="times circle outline large icon"></i>
        </button>

    </div>

    <div class="ui grid" style="margin:10px">

        <div style="padding:0">

            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(1)">
                1
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(2)">
                2
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(3)">
                3
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(4)">
                4
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(5)">
                5
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(6)">
                6
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(7)">
                7
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(8)">
                8
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(9)">
                9
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(0)">
                0
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('-')">
                -
            </button>

            <button class="circular ui icon button" style="margin:5px;height:44px;width:95px; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="KeyboardSearch_Backspace()">
                <i class="arrow left icon"></i>
            </button>
        </div>

        <div style="padding:0;padding-left:30px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('q')">
                q
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('w')">
                w
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('e')">
                e
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('r')">
                r
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('t')">
                t
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('z')">
                z
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('u')">
                u
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('i')">
                i
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('o')">
                o
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('p')">
                p
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('ü')">
                ü
            </button>
        </div>


        <div style="padding:0;padding-left:30px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('a')">
                a
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('s')">
                s
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('d')">
                d
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('f')">
                f
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('g')">
                g
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('h')">
                h
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('j')">
                j
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('k')">
                k
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('l')">
                l
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('ö')">
                ö
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('ä')">
                ä
            </button>
        </div>

        <div style="padding:0;padding-left:60px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('y')">
                y
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('x')">
                x
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('c')">
                c
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('v')">
                v
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('b')">
                b
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('n')">
                n
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('m')">
                m
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue(',')">
                ,
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('.')">
                .
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="KeyboardSearch_ChangeValue('')">
                '
            </button>
        </div>

        <div style="padding:0;padding-left:100px">

            <button class="circular ui icon button" style="margin:5px;height:44px;width:370px;float:left; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="KeyboardSearch_ChangeValue(' ')"></button>




            <!-- <button class="circular ui button" style="margin:5px;height:44px;width:95px;float:left;margin-left: 120px;border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="KeyboardSearch_Close()">
                <span tkey="Close"></span>
            </button> -->
        </div>
    </div>
</div>
